module.exports = __webpack_public_path__ + "img/impiantogiallo.d5cda40f.png";